import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

// import { fetchFailedCampaignPayments } from 'api/campaignApi'; // TODO: Replace with GraphQL
import { currentUser } from 'store/authSlice';
import { CompaniesSelectors, getCustomerDetailsGraphQL } from 'store/companiesSlice';
import { validateCustomerSessionOrLogout } from 'utils/validateCustomerSession';
// import { openNotification } from 'store/notificationSlice'; // TODO: Re-enable with GraphQL

const useAppInit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isUserLoaded = useSelector((state) => state.auth.isLoaded);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!isUserLoaded) {
      dispatch(currentUser());
    }
  }, [dispatch, isUserLoaded, isLoggedIn, location.pathname]);

  // Menu campaigns now use data from main campaigns list - no separate fetch needed

  const hasCompany = useSelector(CompaniesSelectors.all).length > 0;
  const isCompaniesLoaded = useSelector(CompaniesSelectors.isLoaded);
  const isCompaniesLoading = useSelector(CompaniesSelectors.isLoading);
  const hasCompaniesError = useSelector(CompaniesSelectors.hasError);

  // Fetch customer details once when logged in
  useEffect(() => {
    if (isLoggedIn && isUserLoaded && !isCompaniesLoaded && !isCompaniesLoading) {
      dispatch(getCustomerDetailsGraphQL());
    }
  }, [dispatch, isLoggedIn, isUserLoaded, isCompaniesLoaded, isCompaniesLoading]);

  // After admin email change, local Amplify tokens can linger. Re-check session on
  // route change and tab focus so the user is sent to /login (no polling).
  useEffect(() => {
    if (!isLoggedIn || !isUserLoaded) return;
    if (location.pathname.includes('/change-password')) return;

    const runCheck = () => {
      void validateCustomerSessionOrLogout();
    };

    runCheck();

    const onFocus = () => runCheck();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        runCheck();
      }
    };

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [isLoggedIn, isUserLoaded, location.pathname]);

  // Setup-company redirect disabled for customer portal
  // Clear any old localStorage flags that might interfere
  useEffect(() => {
    if (isLoggedIn && isCompaniesLoaded) {
      // Clear the hasCompany flag from localStorage
      localStorage.removeItem('hasCompany');
      
      // If user accidentally lands on setup-company, redirect to campaigns
      if (location.pathname === '/setup-company') {
        navigate('/campaigns');
      }
    }
  }, [isLoggedIn, isCompaniesLoaded, location.pathname, navigate]);
};

export default useAppInit;
